import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'range',
  standalone: false
})
export class RangePipe implements PipeTransform {
  transform(n: number): number[] {
    return [...Array(n).keys()];
  }
}
